import {
    LiabilitiesSinglesResponseType,
    SinglesColumnIdType,
    SinglesSelectionsType,
} from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesWidgets/LiabilitiesWidgetTable/LiabilitiesWidgetTable.types';
import { SinglesColumns } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesWidgets/LiabilitiesWidgetTable/LiabilitiesWidgetTable.consts';
import {
    getSinglesRowClassName,
    getSortIndicator,
} from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesWidgets/LiabilitiesWidgetTable/LiabilitiesWidgetTable.helpers';
import React from 'react';
import { CurrencyType } from 'src_common/common/amount/website-money/currency';

type SinglesTablePropsType = {
    sortColumn: string;
    sortDirection: string;
    handleColumnSort: (column: SinglesColumnIdType) => void;
    selections: SinglesSelectionsType;
    columns: Array<SinglesColumnIdType>;
    liabilities: LiabilitiesSinglesResponseType;
    currency: CurrencyType;
    eventId: number;
};

export const SinglesTable = ({
    sortColumn,
    sortDirection,
    handleColumnSort,
    selections,
    liabilities,
    columns,
    currency,
    eventId,
}: SinglesTablePropsType): JSX.Element => {
    return (
        <table className='table__striped market-liabilities-single'>
            <thead>
                <tr>
                    {columns.map((col) => {
                        const longName = SinglesColumns[col].label;
                        const abbr = 'abbr' in SinglesColumns[col] ? SinglesColumns[col].abbr : longName;

                        return (
                            <th
                                onClick={(): void => handleColumnSort(col)}
                                key={col}
                                title={longName}
                            >
                                {abbr}
                                {getSortIndicator(col, sortColumn, sortDirection)}
                            </th>
                        );
                    })}
                </tr>
            </thead>
            <tbody>
                <tr className='market-liabilities__row--total'>
                    {columns.map((col) => {
                        const totalContent = SinglesColumns[col].total;
                        return totalContent === undefined ? null : (
                            <th
                                key={col}
                                data-test-column-id={`total-top-${col}`}
                            >
                                {totalContent(liabilities.sgl, liabilities, currency)}
                            </th>
                        );
                    })}
                </tr>
                {selections.map((selection) => (
                    <tr
                        data-test-selection-id={selection.id}
                        key={selection.id}
                        id={selection.id}
                        className={getSinglesRowClassName(selection)}
                    >
                        {columns.map((col) => {
                            const routeContent = SinglesColumns[col].route;
                            return (
                                <td
                                    key={col}
                                    data-test-column-id={col}
                                >
                                    {routeContent === undefined
                                        ? SinglesColumns[col].cell(selection, currency)
                                        : routeContent(selection, currency, eventId)}
                                </td>
                            );
                        })}
                    </tr>
                ))}

                <tr className='market-liabilities__row--total'>
                    {columns.map((col) => {
                        const totalContent = SinglesColumns[col].total;
                        return totalContent === undefined ? null : (
                            <th
                                key={col}
                                data-test-column-id={`total-botton-${col}`}
                            >
                                {totalContent(liabilities.sgl, liabilities, currency)}
                            </th>
                        );
                    })}
                </tr>
            </tbody>
        </table>
    );
};
